import { useNavigate } from 'react-router-dom';

export default function CTASection() {
  const navigate = useNavigate();

  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=luxury%20hotel%20grand%20lobby%20interior%20with%20golden%20chandelier%20marble%20floors%20elegant%20furniture%20warm%20ambient%20lighting%20sophisticated%20atmosphere%20cream%20gold%20tones%20reception%20desk%20fresh%20flowers&width=1920&height=800&seq=grand-lisboa-cta-02&orientation=landscape"
        alt="新葡京酒店大堂"
        title="新葡京酒店大堂 - 奢华内饰"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
          开启您的澳门奢华之旅
        </h2>
        <p className="text-sm md:text-base text-background-200/90 mb-8 max-w-xl mx-auto leading-relaxed">
          即日起预订，尊享专属礼遇与最优价格保证。新葡京酒店期待为您打造难忘的澳门回忆。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <button
            onClick={() => navigate('/category/rooms')}
            className="px-10 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            立即预订客房
          </button>
          <button
            onClick={() => navigate('/about')}
            className="px-10 py-3.5 border-2 border-background-300/50 text-background-50 font-medium rounded-lg hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            联系我们
          </button>
        </div>
      </div>
    </section>
  );
}